import { Throwable } from "@wss/error-tracking/throwable";
import { validatePhoneNumber } from "@wss/utilities/form";
import fetchSendProductPriceDiscountTextMessage from "./fetchSendProductPriceDiscountTextMessage";

interface HandleTextMessageSubmissionParams {
  phoneNumber: string;
  itemNumber: string;
}
type TextMessageSuccess = { message: string };

const handleTextMessageSubmission = async ({
  phoneNumber,
  itemNumber,
}: HandleTextMessageSubmissionParams): Promise<
  Throwable<TextMessageSuccess>
> => {
  if (!validatePhoneNumber(phoneNumber)) {
    return {
      isError: true,
      error: new Error("Please enter a valid phone number."),
    };
  }

  const response = await fetchSendProductPriceDiscountTextMessage(
    phoneNumber,
    itemNumber,
  );
  return response.isError
    ? {
        isError: true,
        error: new Error(
          "There was an error sending the text message. Please try again.",
        ),
      }
    : {
        isError: false,
        value: {
          message:
            "A message has been sent to the contact information you provided.",
        },
      };
};

export default handleTextMessageSubmission;
